import React from "react";
import { useNavigate } from "react-router-dom";
import Datatable from "./common/datatable";
import ActionMenu from "./common/menu";
import FallbackImage from "./common/fallbackImage";

const SubIndustryData = ({ data, onEdit, onView, onDelete }) => {
  const navigate = useNavigate();

  const handleView = (subindustry) => {
    const id = subindustry._id || subindustry.id;
    if (onView) {
      onView(subindustry);
    } else {
      navigate(`/sub-industries/view/${id}`);
    }
  };

    const handleEdit = (subindustry) => {
    const id = subindustry._id || subindustry.id;
    if (onEdit) {
        onEdit(subindustry);
    } else {
        navigate(`/sub-industries/edit/${id}`);
    }
  };

  const toBool = (value) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
      const s = value.trim().toLowerCase();
      if (["true", "1", "active", "enabled", "yes"].includes(s)) return true;
      if (["false", "0", "inactive", "disabled", "no"].includes(s))
        return false;
    }
    return false;
  };

  // Columns
  const columns = [
    {
      key: "image",
      label: "Image",
      render: (value) =>
        value ? (
          <FallbackImage
            src={value}
            alt="img"
            style={{ width: 35, height: 35, borderRadius: "4px", objectFit: "cover" }}
          />
        ) : null,
    },
    { key: "title", label: "Title" },
    { key: "description", label: "Description" },
    {
      key: "status",
      label: "Status",
      render: (_v, row) => {
        const raw =
          typeof row?.isActive !== "undefined" ? row.isActive : row?.status;
        const isActive = toBool(raw);
        return (
          <span
            className={`status-badge ${isActive ? "status-active" : "status-expired"}`}
          >
            {isActive ? "Active" : "Inactive"}
          </span>
        );
      },
    },
    {
      key: "actions",
      label: "Actions",
      render: (value, row) => (
        <ActionMenu 
          row={row}
          // onView={handleView}
          onEdit={handleEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];

  return <Datatable data={data} columns={columns} />;
};

export default SubIndustryData;
